// extracted by mini-css-extract-plugin
export default {"pageDisplay":"pageDisplay_pageDisplay__KSO20"};